import React, { useEffect, useState } from 'react'
import { Grid, Typography, Divider, Box, Card, CardContent, CardHeader } from '@mui/material'
import _ from "lodash"
import RestaurantIcon from '@mui/icons-material/Restaurant';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import WarningIcon from '@mui/icons-material/Warning';
import DangerousIcon from '@mui/icons-material/Dangerous';
import '../../../styles/report.css'
import '../../../styles/print.css'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import SmallCardSingle from '../personalreport/SmallCardSingle';
import { PsychologyAlt } from '@mui/icons-material';



const PersonalReportKeyAreaSingle = (props) => {
    const [PrintView, setPrintView] = useState(false)
    useEffect(() => { setPrintView(props.otherprops.PrintView) }, [props])

    const [value, setValue] = React.useState(0);
    const [currentTab, setCurrentTab] = React.useState(props.component)
    const [isFlipped, setIsFlipped] = React.useState(-1)
    const [isFlippedLarge, setIsFlippedLarge] = React.useState(false)

    // const handleChange = (event, newValue) => {
    //     setValue(newValue);
    //     setIsFlipped(-1)
    //     setCurrentTab(props.cards.KeyAreas.KeyAreaArray[newValue])
    // };

    useEffect(() => {
        setIsFlipped(-1)
    }, currentTab)

    const IconFlip = {
        "Mood Corner": <PsychologyAlt />,
        "Food Corner": <RestaurantIcon />
    }

    const sortedSmallCards = _.orderBy(currentTab.Cards.Small, ['ValueGrade'], ['desc'])
    const getColorBottomCard = (valuegrade, opacity) => {
        if (valuegrade == "1") return { background: 'linear-gradient(to bottom, #fff, #fff 92%, rgba(78, 183, 72,' + opacity + ') 175%)', color: 'black', minHeight: '50px' }
        if (valuegrade == "2") return { background: 'linear-gradient(to bottom, #fff, #fff 92%, rgba(231, 198, 30,' + opacity + ') 175%)', color: 'black', minHeight: '50px' }
        else return { background: 'linear-gradient(to bottom, #fff, #fff 92%, rgba(230, 50, 58,' + opacity + ') 175%)', color: 'black', minHeight: '50px' }
    }

    const getColorBottomHeader = (valuegrade, opacity) => {
        if (valuegrade == "1") return { background: 'linear-gradient(to bottom, #fff, #fff 95%, rgba(78, 183, 72,' + opacity + ') 95%, rgba(78, 183, 72,' + opacity + ') 100%)', color: 'black', minHeight: '50px' }
        if (valuegrade == "2") return { background: 'linear-gradient(to bottom, #fff, #fff 95%, rgba(231, 198, 30,' + opacity + ') 95%, rgba(231, 198, 30,' + opacity + ') 100%)', color: 'black', minHeight: '50px' }
        else return { background: 'linear-gradient(to bottom, #fff, #fff 95%, rgba(230, 50, 58,' + opacity + ') 95%, rgba(230, 50, 58,' + opacity + ') 100%)', color: 'black', minHeight: '50px' }
    }


    const getColorDivider = (valuegrade, opacity) => {
        if (valuegrade == "1") return { borderColor: 'linear-gradient(to right bottom, rgba(78, 183, 72,0.8), rgba(78, 183, 72,0.15))', borderRadius: '90%', borderBottomWidth: 2 }
        if (valuegrade == "2") return { borderColor: 'linear-gradient(to right bottom, rgba(231, 198, 30,0.8), rgba(231, 198, 30,0.15))', borderRadius: '90%', borderBottomWidth: 2 }
        else return { borderColor: 'linear-gradient(to right bottom, rgba(230, 50, 58,0.8),rgba(230, 50, 58,0.15))', borderRadius: '90%', borderBottomWidth: 2 }
    }



    const getLargeIcon = (valuegrade) => {
        if (valuegrade == "1") return <HealthAndSafetyIcon fontSize="large" sx={{ color: '#4eb748' }} />
        if (valuegrade == "2") return <WarningIcon fontSize="large" sx={{ color: '#E7C61E' }} />
        else return <DangerousIcon fontSize="large" sx={{ color: '#E6323A' }} />
    }



    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }
    if (props.component) {

        return (

            <Grid item xs={12}>
                <div className="pagebreak" />
                <Box id={"key_area_section_" + currentTab.Label.toLowerCase()} p={1}>
                    <Grid container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={2}>
                        <Grid item xs={10}>
                            <Grid container xs={12}>
                                <Grid item xs={12}>
                                    <Typography variant="h3">{currentTab.Label}</Typography>
                                </Grid>

                                <Grid item xs={12} my={1}>
                                    <Typography ml={1} variant="body2" fontStyle="italic" dangerouslySetInnerHTML={{ __html: currentTab.Resources.ScienceCenter.Content }}></Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={2} sx={{ height: "100%" }}>
                            <Typography variant="h3" align='right'>{
                                currentTab.ValueGrade == 1 ? <HealthAndSafetyIcon sx={{ color: '#4eb748' }} fontSize="inherit" /> : currentTab.ValueGrade == 2 ? <WarningIcon fontSize="inherit" sx={{ color: '#E7C61E' }} /> : <DangerousIcon sx={{ fontSize: '4rem', color: '#E6323A' }} />
                            } {currentTab.Score}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item md={12} xs={12} sx={{}}>
                            <motion.div variants={PrintView === true ? { hidden: { opacity: 1 } } : motionVariants} initial="hidden" animate="show" whileHover={{ scale: 1.1 }} style={{ height: '100%' }}>


                                <Card sx={[{ height: '100%' }
                                    , { border: 0.1, borderColor: "rgba(0,0,0,0.15)" }
                                    //, getShadowLarge(currentTab.Cards.Large.ValueGrade, "1")
                                    , getColorBottomCard(currentTab.Cards.Large.ValueGrade, "0.8")

                                ]}>
                                    <CardHeader
                                        action={
                                            getLargeIcon(currentTab.Cards.Large.ValueGrade)
                                        }
                                        title={currentTab.Cards.Large.CardTitle.length ? currentTab.Cards.Large.CardTitle : 'MISSING TITLE'}
                                        titleTypographyProps={{ variant: 'h5' }}
                                        style={getColorBottomHeader(currentTab.Cards.Large.ValueGrade, "0.6")}

                                    ></CardHeader>


                                    <CardContent >
                                        {currentTab.Cards.Large.YouValue && (

                                            <Box>
                                                <Typography variant="body2" color="text.secondary" fontWeight="bold">
                                                    {currentTab.YouValueLabel}  {currentTab.Cards.Large.YouValue}
                                                </Typography>
                                            </Box>
                                        )}
                                        <Box>
                                            <Typography variant="body2" color="text.secondary">
                                                {currentTab.GoalValueLabel} {currentTab.Cards.Large.GoalValue}
                                            </Typography>
                                        </Box>
                                        <Box mt={1}>
                                            <Typography variant="body2" color="text.secondary" fontWeight="bold">
                                                {currentTab.FrontContentLabel}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography variant="body2" color="text.secondary">
                                                {currentTab.Cards.Large.FrontContent}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Divider orientation='horizontal' sx={[{ m: 2 }, getColorDivider(currentTab.Cards.Large.ValueGrade, 1)]} />
                                        </Box>
                                        <Box >
                                            <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
                                                {currentTab.Cards.Large.BackContent}
                                            </Typography>
                                        </Box>
                                    </CardContent>

                                </Card>

                            </motion.div>
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <Grid container direction="row"
                                justifyContent="flex-start"
                                alignItems="stretch"
                                spacing={2}>
                                {sortedSmallCards.map((small, i) => (
                                    <SmallCardSingle smallCard={small} key={i} PrintView={PrintView} />
                                ))}
                            </Grid>

                        </Grid>

                    </Grid>

                    <Grid container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="stretch"
                        mt={2}
                        spacing={2}
                    >
                        <Grid item md={6} sx={12}>
                            <Card sx={{ border: 0.1, height: '100%', borderColor: "rgba(0,0,0,0.15)" }}>
                                <Box p={2} sx={{ height: "100%" }}>

                                    <Typography variant="h5"><NewspaperIcon />  {currentTab.ReadAboutItLabel}</Typography>
                                    <Divider m={2} orientation="horizontal" variant="middle" sx={{ borderBottomWidth: 2, borderColor: 'linear-gradient(to right bottom, #430089, #82ffa1)', borderRadius: "90%", m: 2 }} />
                                    <Typography ml={1} variant="body1" dangerouslySetInnerHTML={{ __html: currentTab.Resources.ReadAboutIt.Content }}></Typography>
                                </Box>
                            </Card>

                        </Grid>
                        <Grid item md={6} sx={12}>
                            <Card sx={{ border: 0.1, height: '100%', borderColor: "rgba(0,0,0,0.15)" }}>
                                <Box p={2} sx={{ height: "100%" }}>
                                    <Typography variant="h5">{IconFlip[currentTab.CornerLabel]} {currentTab.CornerLabel}</Typography>
                                    <Divider orientation="horizontal" variant="middle" sx={{ borderBottomWidth: 2, borderColor: 'linear-gradient(to right bottom, #430089, #82ffa1)', borderRadius: "90%", m: 2 }} />
                                    <Typography ml={1} variant="body1" dangerouslySetInnerHTML={{ __html: currentTab.Resources.Corner.Content }}></Typography>
                                </Box>
                            </Card>
                        </Grid>
                    </Grid>


                </Box>
            </Grid>
        )
    } else {
        return (<Box></Box>)
    }
}


export default PersonalReportKeyAreaSingle;